export default __webpack_public_path__ + "static/media/doc.8026e2b5.svg";